import { useTranslation } from 'react-i18next'

import { clearReactionPause, useReactionPause } from '@/shared/api/reaction-pause'
import { Modal } from '@/shared/components/Modal'

/**
 * The reaction pause as a modal with an OK button (see reaction-pause.ts);
 * mounted once in AppProviders, fed by the API client.
 */
export function ReactionPauseModal() {
  const { t } = useTranslation('common')
  const message = useReactionPause()
  if (!message) return null

  return (
    <Modal open onClose={clearReactionPause} size="sm">
      <div className="flex flex-col items-center gap-4 text-center">
        <span className="text-5xl" aria-hidden>
          🐢
        </span>
        <p className="text-fg text-lg font-bold">{t('reactions.pauseTitle')}</p>
        <p className="text-fg text-sm leading-relaxed">{message}</p>
        <button
          type="button"
          onClick={clearReactionPause}
          className="bg-primary hover:bg-primary-hover w-full rounded-xl py-2.5 text-sm font-semibold text-white transition"
        >
          {t('actions.ok')}
        </button>
      </div>
    </Modal>
  )
}
